import { Check } from 'lucide-react';
import { motion } from 'motion/react';

import { springs } from '@/shared/lib/motion';

import { SPACE_COLORS } from './colors';

import styles from './ColorPicker.module.scss';

interface Props {
  value: string;
  onChange: (color: string) => void;
}

export function ColorPicker({ value, onChange }: Props) {
  return (
    <div className={styles['picker']} role="radiogroup">
      {SPACE_COLORS.map((color) => (
        <button
          key={color}
          type="button"
          role="radio"
          aria-checked={value === color}
          aria-label={`#${color}`}
          className={styles['swatch']}
          style={{ '--swatch': `#${color}` } as React.CSSProperties}
          onClick={() => {
            onChange(color);
          }}
        >
          {value === color && (
            <motion.span
              className={styles['swatch__check']}
              initial={{ scale: 0.4, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              transition={springs.rubber}
            >
              <Check />
            </motion.span>
          )}
        </button>
      ))}
    </div>
  );
}
